export default {
  count: 1,
  schemaId: 0,
  serverTime: 0,
  session: {},
  meetingInfo: {},
  templateInfo: {},
  user: {
    isRegistration: "", //（0： 未报名， 1： 已报名）
    hasPermission: "", //（0： 没权限，  1： 有权限）
    isLogin: "" //是否登录
  },
  docState: false, // ppt是否大屏
  offsetHide: false, // 视频是否偏移屏外
  templateInfos: {
    pc: {},
    wap: {}
  }
};
